module.exports = __webpack_public_path__ + "static/media/turokafteri_thumb1.5695837a.jpg";